import { render, staticRenderFns } from "./CanvasWrapper.vue?vue&type=template&id=6920db82&scoped=true&"
import script from "./CanvasWrapper.vue?vue&type=script&lang=js&"
export * from "./CanvasWrapper.vue?vue&type=script&lang=js&"
import style0 from "./CanvasWrapper.vue?vue&type=style&index=0&id=6920db82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920db82",
  null
  
)

export default component.exports